import { useCallback, useMemo } from "react";
import { Menu, Dropdown } from "antd";
import { actionMenu } from "svgs";
import { useDispatch } from "react-redux";
import { setModalName, setSelectedServiceCentre, setSelectedUser } from "store/actions";
import { getFullName } from "utils/helpers";
import { ServiceCentre, ServiceCentresState, UserDataItem } from "types";

                    


export default function DropdownAction({
  serviceCentre,
}: {
  serviceCentre: ServiceCentresState["selectedServiceCentre"];
}) {
  const dispatch = useDispatch();

  const onViewTaskDetails = useCallback((e) => {
    e.domEvent.stopPropagation(); 
    dispatch(setModalName("view_task_details"));
  }, [dispatch]);


  const onArchive = useCallback((e) => {
    e.domEvent.stopPropagation(); 
   dispatch(setSelectedServiceCentre(serviceCentre));
      dispatch(setModalName("delete_service_centre"));
  }, [dispatch, serviceCentre]);

  const menu = useMemo(
    () => (
      <Menu>
        <Menu.Item key="3" className="delete-action" onClick={onArchive}>
          Archive
        </Menu.Item>
      </Menu>
    ),
    [onArchive]
  );

  return (
    <Dropdown overlay={menu} trigger={["click"]}>
      <a className="ant-dropdown-link" onClick={(e) => e.stopPropagation()}>{actionMenu}</a>
    </Dropdown>
  );
}
